import { render, staticRenderFns } from "./MarketingMaterialsDialog.vue?vue&type=template&id=0b999174&scoped=true&"
import script from "./MarketingMaterialsDialog.vue?vue&type=script&lang=js&"
export * from "./MarketingMaterialsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b999174",
  null
  
)

export default component.exports